import { render } from "./SetTerms.vue?vue&type=template&id=6daf399b&scoped=true"
import script from "./SetTerms.vue?vue&type=script&lang=js"
export * from "./SetTerms.vue?vue&type=script&lang=js"

import "./SetTerms.vue?vue&type=style&index=0&id=6daf399b&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daf399b"]])

export default __exports__